import { __assign, __rest } from "tslib";
function paramComposer(obj) {
    var params = [];
    Object.keys(obj).forEach(function (key) {
        if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') {
            params.push("".concat(key, "=").concat(obj[key]));
        }
    });
    return "".concat(params.join('&'));
}
export function updateHref(clickLinkData, redirect) {
    var redirectHost = clickLinkData.redirectHost, rest = __rest(clickLinkData, ["redirectHost"]);
    if (redirect.includes(redirectHost)) {
        return redirect;
    }
    return "".concat(redirectHost, "?").concat(paramComposer(__assign(__assign({}, rest), { redirect: redirect.startsWith('http')
            ? redirect
            : new URL(redirect, origin).href })));
}
